import axios from 'axios'
import router from '../router'
import { ElMessage } from 'element-plus'

const orderAPI = axios.create({
  baseURL: '/',
  timeout: 8000,
  headers: { 'Content-Type': 'application/json' }
})

// 请求拦截器：自动携带 token
orderAPI.interceptors.request.use(config => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers['Authorization'] = token
  }
  return config
}, error => Promise.reject(error))

// 响应拦截器：处理未登录
orderAPI.interceptors.response.use(
  response => response,
  error => {
    if (error.response && (error.response.status === 401 || error.response.data?.code === 401)) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      ElMessage.error('登录已过期，请重新登录')
      router.push('/login')
    }
    return Promise.reject(error)
  }
)

/** 获取当前用户 ID */
export const getCurrentUserId = () => {
  try {
    const user = JSON.parse(localStorage.getItem('user') || '{}')
    return user.id || user.userId || user.uid || null
  } catch {
    return null
  }
}

export const cartService = {
  /** 添加商品到购物车  POST /cart/add */
  addCart(data) {
    // data: { userId, productId, count }
    return orderAPI.post('/cart/add', data)
  },

  /** 获取用户购物车列表  GET /cart/list/{userId} */
  getCartList(userId) {
    return orderAPI.get(`/cart/list/${userId}`)
  },

  /** 更新购物车商品数量  PUT /cart/update */
  updateCart(data) {
    // data: { id, count } 或 { userId, productId, count }
    return orderAPI.put('/cart/update', data)
  },

  /** 删除购物车商品  DELETE /cart/delete/{id} */
  deleteCart(id) {
    return orderAPI.delete(`/cart/delete/${id}`)
  }
}

export const orderService = {
  /** 创建订单  POST /order/create */
  createOrder(data) {
    // data: { userId, items: [...], totalAmount, ... }
    return orderAPI.post('/order/create', data)
  },

  /** 获取用户订单列表  GET /order/list/{userId} */
  getOrderList(userId) {
    return orderAPI.get(`/order/list/${userId}`)
  },

  /** 取消订单  POST /order/cancel/{id} */
  cancelOrder(id) {
    return orderAPI.post(`/order/cancel/${id}`)
  },

  /** 支付订单  POST /order/pay/{id} */
  payOrder(id) {
    return orderAPI.post(`/order/pay/${id}`)
  }
}

export default orderAPI
